var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMdSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1634 28.2989H30.1203L29.4111 27.5939C31.9185 24.6961 33.4445 20.8907 33.4445 16.7307C33.4445 16.7286 33.4445 16.7244 33.4445 16.7222C33.4445 7.48628 25.9582 0 16.7222 0C7.48628 0 0 7.48628 0 16.7222C0 25.9582 7.48628 33.4445 16.7222 33.4445C16.7265 33.4445 16.7307 33.4445 16.7349 33.4445C20.8949 33.4445 24.6961 31.9185 27.615 29.3985L28.3031 30.1224V32.1591L41.1629 45L44.9979 41.1651L32.1655 28.301L32.1634 28.2989ZM16.7201 28.2989C10.325 28.2989 5.14352 23.1152 5.14352 16.7222C5.14352 10.3293 10.3271 5.14563 16.7201 5.14563C23.1152 5.14563 28.2968 10.3293 28.2968 16.7222C28.2968 23.1152 23.1131 28.2989 16.7201 28.2989Z",
    fill: "#58585A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdSearch);
export default __webpack_public_path__ + "static/media/ic-md-search.9bfb2cffe34297cb42506b3f874c5fa2.svg";
export { ForwardRef as ReactComponent };